import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Protagonist from "./components/Protagonist";
import RoleSettings from "./components/RoleSettings";
import Relationships from "./components/Relationships";
import StoryArcs from "./components/StoryArcs";
import Recommendations from "./components/Recommendations";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!visible) return null;
  return (
    <a
      href="#hero"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-50 grid h-11 w-11 place-items-center rounded-full bg-primary-500 text-background-50 shadow-none hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line w-5 h-5 flex items-center justify-center"></i>
    </a>
  );
}

export default function Home() {
  return (
    <main className="bg-background-50 font-body text-foreground-900 antialiased">
      <Navbar />
      <Hero />
      <Protagonist />
      <RoleSettings />
      <Relationships />
      <StoryArcs />
      <Recommendations />
      <Faq />
      <About />
      <Contact />
      <Footer />
      <BackToTop />
    </main>
  );
}